import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { PRODUCT_SELECTOR_FRAGMENT } from 'graphql/fragments/product-selector';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_SELECTOR_ASSIGNMENTS_MUTATION = gql`
  mutation updateSelectorAssignments(
    $documentVersion: DocumentVersionInput!,
    $lineId: String!,
    $variableAssignments: [VariableAssignmentInput!]!,
    $withConfiguration: Boolean!,
    $datamodelVersionId: ID!,
    $filtersId: ID!,
    $frameImageId: ID!,
    $vtzFileId: ID!,
    $elementFilterId: ID!,
    $typeFilterId: ID!
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        line(id: $lineId) {
          configuration {
            setAssignments(variableAssignments: $variableAssignments) {
              line {
                ...ProductSelectorFragment
              }
            }
          }
        }
      }
    }
  }
  ${PRODUCT_SELECTOR_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateSelectorAssignmentsMutation extends Mutation<RootMutation> {
  document = UPDATE_SELECTOR_ASSIGNMENTS_MUTATION;
}
